import { Skeleton } from "src/atoms/Skeleton";
import { theme } from "src/theme";
import { PromotionBlockSkeletonWrapper } from "./ProductList.styled";

function PromotionBlockSkeleton(): JSX.Element {
  return (
    <PromotionBlockSkeletonWrapper>
      <Skeleton height={theme.space.space48} />
    </PromotionBlockSkeletonWrapper>
  );
}

export { PromotionBlockSkeleton };
